import React from 'react';
import styles from './PlatformsGrid.module.scss';
import _ from 'lodash';
import {$t} from "../../helpers/translator";
import PlatformCard from "../miscellaneous/PlatformCard/PlatformCard";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import DataTableGrid from "../miscellaneous/DataTableGrid/DataTableGrid";
import api from "../../helpers/api";
import Input from "../miscellaneous/Input/Input";
import {getClinics} from "../../store/data-slice";
import {connect} from "react-redux";


class PlatformsGrid extends React.Component {
    static defaultProps = {
        header: $t('global.machines.platforms'),
        detached: false,
        userType: 2
    }

    constructor(props) {
        super(props);

        this.state = {
            userType: 2,    //setting type clinic as default
            platforms: [],
            updateKey: 0,

            pagination: null,
            payload: {
                sort: 'created_at',
                order: 'asc',   // or desc
                search: '',
                clinic: '',   // or id
                page: 1,
                per_page: 10,
                usage: false,
                // status: this.props.detached && this.props.userType === 5 ? 'detached' : 'attached', //all / attached / detached
                attachmentStatus: 'all',
                connectionStatus: 'all',
            },
            tableLoading: false,

            sortingOptions: [{
                label: $t('global.machines.platformName'), value: 'machine_name'
            }, {
                label: $t('global.machines.platformId'), value: 'machine_id'
            }, {
                label: $t('global.machines.dateAdded'), value: 'created_at'
            },],
            selectedSortingOption: {
                label: $t('global.machines.dateAdded'), value: 'created_at'
            },

            clinicOptions: [{
                label: $t('global.machines.allClinics'), value: ''
            },],
            selectedClinicOption: {
                label: $t('global.machines.allClinics'), value: ''
            },

            onlineStatusOptions: [{
                label: $t('global.machines.modes.all'), value: 'all'
            }, {
                label: $t('global.machines.modes.online'), value: 'online'
            }, {
                label: $t('global.machines.modes.offline'), value: 'offline'
            },],
            selectedOnlineStatusOption: {label: $t('global.machines.modes.all'), value: ''},

            attachedDetachedOptions: [{
                label: $t('global.machines.modes.all'), value: 'all'
            }, {
                label: $t('global.machines.modes.attached'), value: 'attached'
            }, {
                label: $t('global.machines.modes.detached'), value: 'detached'
            },],
            selectedAttachedDetachedOption: {
                label: $t('global.machines.modes.all'), value: 'all'
            },

            searchString: '',

        };
    }

    async componentDidMount() {
        let state = this.state;

        if (this.props.perPage) {
            state.payload.per_page = this.props.perPage;
        }

        if (this.props.clinicId) {
            state.payload.clinic = this.props.clinicId;
        }

        if (this.props.userType && this.props.userType !== 2) {
            state.userType = this.props.userType;
        }

        state.payload.detached = !!this.props.detached;
        state.payload.usage = !!this.props.getUsage;

        this.setState(state, async () => {
            await this.getPlatforms();
            await this.getClinics();
        })
    }


    async getPlatforms() {
        this.setState({tableLoading: true}, async () => {
            try {
                let payload = {...this.state.payload};
                payload.detached = (!!this.props.detached).toString();
                // console.log('>>>', payload);
                let res = await api.get(`platform?sort=${payload.sort}&order=${payload.order}&clinic=${payload.clinic}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&get_usage=${payload.usage}&attachmentStatus=${payload.attachmentStatus}&connectionStatus=${payload.connectionStatus}`);
                //&start_date=${moment(payload.start_date).format('YYYY-MM-DD')}&end_date=${moment(payload.end_date).format('YYYY-MM-DD')}`)

                let pagination = null;
                let platforms = [];
                if (res && res.data && res.data.success) {
                    this.setState({platforms: [], pagination: pagination}, () => {
                        // console.log(this.state.updateKey, res.data.data.data)
                        _.forEach(res.data.data.data, (v, k) => {
                            platforms.push(<div className={styles.cardContainer} key={this.state.updateKey}>
                                <PlatformCard {...this.props} platform={v} userType={this.props.userType}
                                              detached={this.props.detached}/>
                            </div>)
                        })

                        pagination = res.data.data.pagination;
                        this.setState({
                            platforms: platforms,
                            pagination: pagination,
                            updateKey: this.state.updateKey + 1
                        });
                    })
                }

            } catch (e) {
                console.error('err get platforms:', e);
            } finally {
                this.setState({tableLoading: false});
            }
        });
    }

    async getClinics() {
        if (this.state.userType === 2) {
            return;
        }

        // try {
        //     let clinics = [...this.state.clinicOptions];
        //     let res = await api.get('/general/clinics');
        //
        //     if (res && res.data && res.data.success) {
        //         _.forEach(res.data.data, (v, k) => {
        //             let clinic = {
        //                 label: v.name, value: v.id,
        //             }
        //             clinics.push(clinic)
        //         })
        //         this.setState({clinicOptions: clinics})
        //     }
        // } catch (e) {
        //     console.error('err get clinics (platforms pg):', e);
        // }

        let clinics = [...await this.props.dispatch(getClinics())]

        clinics.unshift({
            label: $t('global.applicators.allClinics'), value: ''
        })
        this.setState({clinicOptions: clinics})
    }


    dataTableActionHandler(data) {
        if (data.key === 'page') {
            let payload = {...this.state.payload};
            payload.page = data.value;

            this.setState({payload: payload}, async () => {
                await this.getPlatforms();
            });
        }
    }


    fieldChangeHandler(name, data) {
        // console.log('>> selected:', name, data)
        if (name === 'applicatorSN') {
            this.setState({
                applicatorNewSN: data.target.value,
                applicatorNewSNError: ''
            });
            return;
        }

        let payload = {...this.state.payload};
        let selectedSortingOption = {...this.state.selectedSortingOption};
        let selectedClinicOption = {...this.state.selectedClinicOption};
        let selectedOnlineStatusOption = {...this.state.selectedOnlineStatusOption};
        let selectedAttachedDetachedOption = {...this.state.selectedAttachedDetachedOption};

        payload.page = 1;

        if (name === 'sort') {
            payload.sort = data.value;
            selectedSortingOption = data;
        }
        if (name === 'clinic') {
            payload.clinic = data.value;
            selectedClinicOption = data;
        }
        if (name === 'connectionStatus') {
            payload.connectionStatus = data.value;
            selectedOnlineStatusOption = data;
        }
        if (name === 'attachmentStatus') {
            payload.attachmentStatus = data.value;
            selectedAttachedDetachedOption = data;
        }

        this.setState({
            payload: payload,
            selectedSortingOption: selectedSortingOption,
            selectedClinicOption: selectedClinicOption,
            selectedAttachedDetachedOption: selectedAttachedDetachedOption,
            selectedOnlineStatusOption: selectedOnlineStatusOption
        }, async () => {
            await this.getPlatforms();
        });
    }

    nameSearchHandler(e) {
        let payload = {...this.state.payload};
        payload.search = e.target.value;
        payload.page = 1;

        this.setState({payload: payload}, async () => {
            await this.getPlatforms();
        });
    }

    datesChangeHandler(dates) {
        let payload = {...this.state.payload};
        payload.start_date = dates.startDate;
        payload.end_date = dates.endDate;

        this.setState({
            payload: payload
        }, async () => {
            // console.log(this.state);
            await this.getPlatforms();
        });
    }

    changeMode(mode) {
        let state = {...this.state};
        state.mode = mode;
        state.payload.status = mode;
        this.setState(state, async () => {
            await this.getPlatforms();
        })
    }

    render() {
        return (<div className={styles['container']}>
                <div className={styles['box']}>
                    <div className={'alma-box'}>
                        <div className={'alma-box-header'}>
                            <div>
                                <h3>{this.props.header}</h3>
                            </div>
                        </div>

                        <div className={'alma-fields-row'}>
                            {
                                this.props.userType > 2 ?
                                    <div className={'alma-field-container'}>
                                        <div className={'alma-field-header'}>{$t('global.machines.clinics')}</div>
                                        <MultiSelect
                                            searchable={true}
                                            options={this.state.clinicOptions}
                                            selected={this.state.selectedClinicOption}
                                            onValueChange={(data) => this.fieldChangeHandler('clinic', data)}
                                        />
                                    </div>
                                    :
                                    null
                            }

                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.machines.sortBy')}</div>
                                <MultiSelect
                                    options={this.state.sortingOptions}
                                    selected={this.state.selectedSortingOption}
                                    onValueChange={(data) => this.fieldChangeHandler('sort', data)}
                                />
                            </div>

                            {
                                this.props.userType >= 5 ?
                                    <div className={'alma-field-container'}>
                                        <div
                                            className={'alma-field-header'}>{$t('global.machines.attachedDetached')}</div>
                                        <MultiSelect
                                            options={this.state.attachedDetachedOptions}
                                            selected={this.state.selectedAttachedDetachedOption}
                                            onValueChange={(data) => this.fieldChangeHandler('attachmentStatus', data)}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.machines.onlineStatus')}</div>
                                <MultiSelect
                                    options={this.state.onlineStatusOptions}
                                    selected={this.state.selectedOnlineStatusOption}
                                    onValueChange={(data) => this.fieldChangeHandler('connectionStatus', data)}
                                />
                            </div>
                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.machines.searchPlatform')}</div>
                                <Input name="search"
                                       autoComplete={false}
                                       delay={500}
                                       className={'alma-input'}
                                       type="text"
                                       value={this.state.payload.search}
                                       placeholder={$t('global.machines.platformNameOrId')}
                                       onChange={(e) => this.nameSearchHandler(e)}/>
                            </div>
                        </div>

                        <div>
                            <DataTableGrid data={this.state.platforms}
                                           pagination={this.state.pagination}
                                           loading={this.state.tableLoading}
                                           onAction={(e) => this.dataTableActionHandler(e)}
                            />
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}


// export default PlatformsGrid;

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(PlatformsGrid);